export enum QuestionTypeType {
  ADJECTIVES_FOR_PROPERTY = 'adjectives_for_property',
  ADJECTIVES_FOR_PROPERTY_SUMMARY = 'adjectives_for_property_summary',
  GIF = 'gif',
  TEXTAREA = 'textarea',
  RATING = 'rating',
  RATING_V2 = 'rating_v2',
  RATING_SUMMARY = 'rating_summary',
  HOLISTIC_SUMMARY = 'holistic_summary',
  TITLE_DESCRIPTION = 'title_description',
}

export enum QuestionVisibilityType {
  SELF_REVIEW = 'self_review',
  NON_SELF_REVIEW = 'non_self_review',
}

export enum FormTypeType {
  peer_review = 'peer_review',
  self_peer_review = 'self_peer_review',
  manager_peer_review = 'manager_peer_review',
  compilation = 'compilation',
  feedback = 'feedback',
}

export interface Question {
  key: string;
  type: QuestionTypeType;
  placeholder?: string;
  header: string;
  description: string;
  optional?: boolean;
  private?: boolean;
  /** Allow other data for custom option */
  [x: string]: any;
}

export interface AdjectivesForPropertyQuestionType extends Question {
  property?: string;
  adjectives: {
    negative: string[];
    positive: string[];
  };
}

// @ts-ignore
export type TitleDescriptionType = Question;
// @ts-ignore
export type TextareaQuestionType = Question;
// @ts-ignore
export type GifQuestionType = Question;
// @ts-ignore
export interface RatingSummaryQuestionType extends Question {
  summarizedQuestionKey: string;
}
// @ts-ignore
export interface AdjectivesForPropertySummaryQuestionType extends Question {
  summarizedQuestionKey: string;
}

export type RatingOptionType = {
  label: string;
  number: number;
};

export interface RatingQuestionType extends Question {
  values: Array<RatingOptionType>;
  showExplanation: boolean;
  explanationDescription: string;
}

export type QuestionType =
  | TitleDescriptionType
  | AdjectivesForPropertyQuestionType
  | TextareaQuestionType
  | GifQuestionType
  | RatingQuestionType
  | RatingSummaryQuestionType
  | AdjectivesForPropertySummaryQuestionType;

export type ReviewFormTemplateType = {
  formType: FormTypeType;
  questions: QuestionType[];
};
